import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DataContextService } from '../services/datacontext.service';
import { SpinnerService } from './spinner/spinner.service';
import { filter, tap } from 'rxjs/operators';

@Injectable()
export class MasterDataResolver implements CanActivate {
  constructor(private dataContextService: DataContextService, private spinnerService: SpinnerService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.spinnerService.start();
    return this.dataContextService.masterDadaLoaded$.asObservable().pipe(
      filter(v => v),
      tap(val => {
        if (val) {
          this.spinnerService.stop();
        }
      })
    );
  }
}
